// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import Dropdown from './dropdown';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const StatesInCountryDropdown = props =>
    <div className='labeled-string'>
        <span className='data-label'>
            <sup></sup><FormattedMessage id='STATE'/>
        </span>
        <Dropdown
            data={props.statesInCountry}
            name='state'
            onItemChange={props.onItemChange}
            text='SELECT_STATE'
            value='SELECT_STATE'
        />
    </div>;

StatesInCountryDropdown.displayName = 'StatesInCountryDropdown';
StatesInCountryDropdown.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statesInCountry: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default StatesInCountryDropdown;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/dropdowns/states-in-country-dropdown.js